import { render } from "./NavTabItem.vue?vue&type=template&id=bec0e534"
import script from "./NavTabItem.vue?vue&type=script&lang=js"
export * from "./NavTabItem.vue?vue&type=script&lang=js"
script.render = render

export default script